import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-investor',
  templateUrl: './add-investor.component.html',
  styleUrls: ['./add-investor.component.scss']
})
export class AddInvestorComponent implements OnInit {

formData: any = {
  name: '',
  email: '',
  employee_id: '',
  city_id: '',
  phone: '',
  identity_number: '',
  nationality_id: '',
  image: null,
};
  employee: any;
  cites: any;
  // cities: any;
  cities: any[] = [];

  imageInput: any;
  countries: any;
  currentLang: string | undefined;
  imgInV: any;
 
 
  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,
     private translate: TranslateService
  ) {}

    ngOnInit(): void {
             this.currentLang = localStorage.getItem('currentLang') || 'ar';

      this. getCountries();
  this.apisService.employee().subscribe({ 
      next:(response:any)=> { 
        this.employee = response.data || [] ;
        console.log('response is' , this.employee)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })
    }

    // getCities(){
    //    this.apisService.getCities().subscribe({ 
    //   next:(response:any)=> { 
    //     this.cities = response.data || [] ;
    //     console.log('response from cites ' , this.cities)
    //   }, 
    //   error:(err)=> { 
    //     console.log('error in fetching', err)
    //   }
    // })
    // }
     onNationalityChange(): void {
    if (this.formData.nationality_id) {
      this.getCities(this.formData.nationality_id);
            console.log('his.formData.nationality_id:', this.formData.nationality_id);

      // إعادة تعيين المدينة عند تغيير الجنسية
      this.formData.city_id = '';
    } else {
      this.cities = [];
      this.formData.city_id = '';
    }
  }
//    getCities(nationalityId: string): void {
//   this.apisService.getCitiesById(nationalityId).subscribe({
//     next: (response: any) => {
//       this.cities = response.data ? [response.data] : [];
//       console.log('Cities loaded:', this.cities);
//     },
//     error: (err) => {
//       console.log('Error fetching cities:', err);
//       this.cities = [];
//     }
//   });
// }

  getCities(nationalityId: string): void {
  this.apisService.getCitiesById(nationalityId).subscribe({
    next: (response: any) => {
      // assign array directly
      this.cities = response.data || [];
      console.log('Cities loaded:', this.cities);
    },
    error: (err) => {
      console.log('Error fetching cities:', err);
      this.cities = [];
    }
  });
}
  getCountries(){
       this.apisService.getCountriesM().subscribe({ 
      next:(response:any)=> { 
        this.countries = response.data || [] ;
        console.log('response from countries ' , this.countries)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })
    }
 
//   onFileSelected(event: any): void {
//   if (event.target.files.length > 0) {
//     this.formData.image = event.target.files[0];
//   }
// }
// onFileSelected(event: any): void {
//   const file = event.target.files[0];
//   if (file) {
//     const reader = new FileReader();
//     reader.onload = (e: any) => {
//       this.formData.image = e.target.result;
//     };
//     reader.readAsDataURL(file);
//   }
// }

removeImage(): void {
  this.formData.image = null;
  // إعادة تعيين حقل الرفع
  this.imageInput.nativeElement.value = '';
}
    cancel(): void {
      this.router.navigate(['/investors']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


     private isSaudiPhoneNumber(phone: string): boolean {
    // Saudi phone number validation
    const saudiPhoneRegex = /^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/;
    return saudiPhoneRegex.test(phone);
  }
  onFileSelected(event: any): void {
  const file = event.target.files[0];
  this.imgInV= file
  if (file) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.formData.image = e.target.result;
      
    };
    reader.readAsDataURL(file);
  }
}
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit(): void {
  const form = new FormData();
  form.append('name', this.formData.name);
  if (this.formData.email?.trim()) {
    form.append('email', this.formData.email.trim());
  }
  form.append('employee_id', this.formData.employee_id);
  form.append('city_id', this.formData.city_id);
  form.append('phone', this.formData.phone);
  form.append('nationality', this.formData.nationality_id);
  form.append('identity_number', this.formData.identity_number);

  if (this.imgInV) {
    form.append('image', this.imgInV);
  }

  this.apisService.addInvestor(form).subscribe({
    next: (response: any) => {
      this.translate.get([
        'MENU.DASHBOARD.INVESTOR_ADD_SUCCESS_TITLE',
        'MENU.DASHBOARD.INVESTOR_ADD_SUCCESS_MESSAGE'
      ]).subscribe(translations => {
        this.toastr.success(
          translations['MENU.DASHBOARD.INVESTOR_ADD_SUCCESS_MESSAGE'],
          translations['MENU.DASHBOARD.INVESTOR_ADD_SUCCESS_TITLE'],
          {
            positionClass: 'toast-top-center',
            timeOut: 3000,
            progressBar: true,
            closeButton: true
          }
        );
      });

      this.router.navigate(['/investors']);
    },

    error: (error: any) => {
      console.error('Error adding investor:', error);



       // 1️⃣ If backend sends a direct message → show it
  if (error?.error?.message) {
    this.toastr.error(
      error.error.message,
      this.translate.instant('MENU.DASHBOARD.ERROR_TITLE'),
      {
        positionClass: 'toast-top-center',
        timeOut: 4000,
        progressBar: true,
        closeButton: true
      }
    );
    return;
  }
  // 2️⃣ If backend sends validation errors → show first one
  if (error?.error?.errors) {
    const firstKey = Object.keys(error.error.errors)[0];
    const firstMessage = error.error.errors[firstKey]?.[0];

    if (firstMessage) {
      this.toastr.error(
        firstMessage,
        this.translate.instant('MENU.DASHBOARD.ERROR_TITLE'),
        {
          positionClass: 'toast-top-center',
          timeOut: 4000,
          progressBar: true,
          closeButton: true
        }
      );
      return;
    }
  }

  // 3️⃣ Fallback (translated generic error)
  this.toastr.error(
    this.translate.instant('MENU.DASHBOARD.GENERIC_ERROR'),
    this.translate.instant('MENU.DASHBOARD.ERROR_TITLE')
  );
  
      this.translate.get([
        'MENU.DASHBOARD.ERROR_TITLE',
        'MENU.DASHBOARD.GENERIC_ERROR',
        'MENU.DASHBOARD.FIELD_EMAIL_ERROR',
        'MENU.DASHBOARD.FIELD_EMPLOYEE_ERROR',
        'MENU.DASHBOARD.FIELD_CITY_ERROR',
        'MENU.DASHBOARD.FIELD_NAME_ERROR',
        'MENU.DASHBOARD.FIELD_PHONE_ERROR',
        'MENU.DASHBOARD.FIELD_NATIONALITY_ERROR',
        'MENU.DASHBOARD.FIELD_IDENTITY_NUMBER_ERROR'
      ]).subscribe(translations => {
        if (error.error && error.error.errors) {
          const errors = error.error.errors;

          if (errors.email)
            this.toastr.error(
              translations['MENU.DASHBOARD.FIELD_EMAIL_ERROR'],
              translations['MENU.DASHBOARD.ERROR_TITLE']
            );
          if (errors.employee_id)
            this.toastr.error(
              translations['MENU.DASHBOARD.FIELD_EMPLOYEE_ERROR'],
              translations['MENU.DASHBOARD.ERROR_TITLE']
            );
          if (errors.city_id)
            this.toastr.error(
              translations['MENU.DASHBOARD.FIELD_CITY_ERROR'],
              translations['MENU.DASHBOARD.ERROR_TITLE']
            );
          if (errors.name)
            this.toastr.error(
              translations['MENU.DASHBOARD.FIELD_NAME_ERROR'],
              translations['MENU.DASHBOARD.ERROR_TITLE']
            );
          if (errors.phone)
            this.toastr.error(
              translations['MENU.DASHBOARD.FIELD_PHONE_ERROR'],
              translations['MENU.DASHBOARD.ERROR_TITLE']
            );
          if (errors.nationality)
            this.toastr.error(
              translations['MENU.DASHBOARD.FIELD_NATIONALITY_ERROR'],
              translations['MENU.DASHBOARD.ERROR_TITLE']
            );
          if (errors.identity_number)
            this.toastr.error(
              translations['MENU.DASHBOARD.FIELD_IDENTITY_NUMBER_ERROR'],
              translations['MENU.DASHBOARD.ERROR_TITLE']
            );
        } else {
          this.toastr.error(
            translations['MENU.DASHBOARD.GENERIC_ERROR'],
            translations['MENU.DASHBOARD.ERROR_TITLE']
          );
        }
      });
    }
  });
}


}
